import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { ExpendedReport } from './ExpandedReport';
import { GreySummary } from './GreySummary';

interface FooterProps {
  data: { title: string; sideSections: any; _rawText: any };
}

export const Footer: FC<FooterProps> = ({ data }) => {
  const [open, setOpen] = useState(false);
  const [activeSection, setActiveSection] = useState(0);
  const [sectionChanged, setSectionChanged] = useState(false);
  const { title, sideSections } = data;
  const toggle = () => {
    setOpen(!open);
  };

  const changeActiveSection = (id: number) => {
    setActiveSection(id);
    setSectionChanged(!sectionChanged);
  };

  const buttonText = open ? 'CLOSE ENDNOTES' : 'EXPAND ENDNOTES';
  return (
    <>
      <GreySummary open={true}>
        <StyledFooter>
          <div>
            <h1> {title} </h1>
            <div className="button-container">
              <button
                onClick={toggle}
                className={open ? 'black-transparent' : 'red'}
              >
                {buttonText}
              </button>
            </div>
          </div>
        </StyledFooter>
      </GreySummary>

      <ExpendedReport
        open={open}
        sections={sideSections}
        activeSection={activeSection}
        changeActiveSection={changeActiveSection}
        sectionChanged={sectionChanged}
        mainTitle={title}
        footer={true}
      />
    </>
  );
};

const StyledFooter = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  min-height: 50vh;
  align-items: center;

  .button-container {
    min-width: 300px;
    @media (max-width: 868px) {
      min-width: 185px;
    }
  }

  h1 {
    text-align: center;
    min-width: 100%;
  }
`;
